import { useEffect, useState } from "react";

export type Route =
  | "overview"
  | "workshops"
  | "workshop-detail"
  | "codes"
  | "analytics"
  | "tickets"
  | "leads"
  | "haydovchilar"
  | "app-version";

export type Location =
  | { route: "overview" }
  | { route: "workshops" }
  | { route: "workshop-detail"; id: number }
  | { route: "codes" }
  | { route: "analytics" }
  | { route: "tickets" }
  | { route: "leads" }
  | { route: "haydovchilar" }
  | { route: "app-version" };

function parseHash(): Location {
  const h = window.location.hash.replace(/^#\/?/, "");
  if (!h || h === "overview") return { route: "overview" };
  if (h === "workshops") return { route: "workshops" };
  if (h === "codes") return { route: "codes" };
  if (h === "analytics") return { route: "analytics" };
  if (h === "tickets") return { route: "tickets" };
  if (h === "leads") return { route: "leads" };
  if (h === "haydovchilar") return { route: "haydovchilar" };
  if (h === "app-version") return { route: "app-version" };
  const m = h.match(/^workshops\/(\d+)$/);
  if (m) return { route: "workshop-detail", id: parseInt(m[1], 10) };
  return { route: "overview" };
}

function buildHash(loc: Location): string {
  switch (loc.route) {
    case "overview": return "#/overview";
    case "workshops": return "#/workshops";
    case "workshop-detail": return `#/workshops/${loc.id}`;
    case "codes": return "#/codes";
    case "analytics": return "#/analytics";
    case "tickets": return "#/tickets";
    case "leads": return "#/leads";
    case "haydovchilar": return "#/haydovchilar";
    case "app-version": return "#/app-version";
  }
}

export function useHashRoute(): [Location, (loc: Location) => void] {
  const [loc, setLoc] = useState<Location>(parseHash);
  useEffect(() => {
    const onHash = () => setLoc(parseHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  function navigate(next: Location) {
    const target = buildHash(next);
    if (window.location.hash !== target) {
      window.location.hash = target;
    } else {
      setLoc(next);
    }
  }
  return [loc, navigate];
}
